import { TextField } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { ButtonWithLoader } from 'components/reusable/button-loader';
import { setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { changePassword } from 'store/sagas/sagas';
export const Password = () => {
    const { state, asyncDispatch, dispatch } = useGlobalState();
    const [isLoading, setIsLoading] = useState(false);
    const user = {
        ...state.user
    };
    const [oldPassword, setOldPassword] = useState('');
    const handleChangeOldPassword = useCallback((e) => {
        setOldPassword(e.target.value);
    }, []);
    const [password, setPassword] = useState('');
    const handleChangePassword = useCallback((e) => {
        setPassword(e.target.value);
    }, []);
    const submitIsDisabled = password.length === 0;
    const onSubmitPassword = (event) => {
        event.preventDefault();
        setIsLoading(true);
        asyncDispatch(changePassword({
            newPassword: password,
            oldPassword
        }))
            .then(() => {
            setIsLoading(false);
            setPassword('');
            setOldPassword('');
            dispatch(setMessages({
                severity: 'success',
                value: 'Password changed successfully'
            }));
        })
            .catch(() => {
            setIsLoading(false);
        });
    };
    return (React.createElement("form", { autoComplete: "off", className: "g-form", noValidate: true, onSubmit: onSubmitPassword },
        React.createElement("span", { className: "title" }, "Change Password"),
        React.createElement(TextField, { className: "u-margin-bottom-small", disabled: !user.emailVerified, label: "Old password", onChange: handleChangeOldPassword, required: true, type: "password", value: oldPassword }),
        React.createElement(TextField, { className: "u-margin-bottom-small", disabled: !user.emailVerified, label: "New password", onChange: handleChangePassword, required: true, type: "password", value: password }),
        React.createElement(ButtonWithLoader, { disabled: submitIsDisabled, isLoading: isLoading, name: "Update password" }),
        React.createElement(Link, { className: "link-without-underline g-link u-margin-top-medium u-margin-bottom-medium", to: "/forgot-password" }, "Forgot Password?")));
};
